import { render } from "./GameProfits.vue?vue&type=template&id=dae42f24&scoped=true"
import script from "./GameProfits.vue?vue&type=script&lang=js"
export * from "./GameProfits.vue?vue&type=script&lang=js"

import "./GameProfits.vue?vue&type=style&index=0&id=dae42f24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dae42f24"

export default script